var _defs, _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    reserveAspectRatio: "none",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "16.6199552%",
    x2: "50%",
    y2: "119.282511%",
    id: "ops-genie-gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2684FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC",
    offset: "82%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.179673%",
    y1: "24.2686242%",
    x2: "67.7136955%",
    y2: "89.1691886%",
    id: "ops-genie-gradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2684FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC",
    offset: "62%"
  })))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "integration-email",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#8DC5FF",
    points: "56.451,26.693 23.549,26.693 40,38.531  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8DC5FF",
    d: "M39.999,0.123c-22.022,0-39.876,17.855-39.876,39.878c0,22.023,17.854,39.876,39.876,39.876                 c22.024,0,39.878-17.853,39.878-39.876C79.877,17.978,62.023,0.123,39.999,0.123z M65.833,58.787H14.167V21.213h51.666V58.787z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8DC5FF",
    points: "61.919,29.51 40,45.282 19.802,29.51 19.802,54.873 61.919,54.873  "
  })))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "integration-opsgenie",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#ops-genie-gradient) #1b76f1",
    cx: 32.909589,
    cy: 20.2520548,
    r: 19.5506849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2438356,78.5753425 C18.4755173,70.4303424 7.85650563,59.3301861 0.284931507,46.2136986 C-0.00774534394,45.6879359 -0.0713920321,45.0649684 0.108916623,44.4908822 C0.289225277,43.916796 0.697628729,43.4420897 1.23835616,43.1780822 L16.0438356,35.9123288 C17.0794911,35.4073079 18.3293451,35.790405 18.9041096,36.7890411 C26.3894632,49.3348277 37.457847,59.3536233 50.6849315,65.5561644 C45.8067297,70.4712858 40.4046274,74.8370664 34.5753425,78.5753425 C33.556026,79.2117766 32.263152,79.2117766 31.2438356,78.5753425 Z",
    fill: "url(#ops-genie-gradient-2) #1f7bf6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5753425,78.5753425 C47.3453119,70.4323526 57.9647538,59.3317466 65.5342466,46.2136986 C65.8276802,45.6893026 65.8929423,45.0674296 65.7147675,44.4935409 C65.5365926,43.9196522 65.1306095,43.4440863 64.5917808,43.1780822 L49.7753425,35.9123288 C48.739687,35.4073079 47.489833,35.790405 46.9150685,36.7890411 C39.4312873,49.3361163 28.3624571,59.355316 15.1342466,65.5561644 C20.0094776,70.4745748 25.4119582,74.8406611 31.2438356,78.5753425 C32.263152,79.2117766 33.556026,79.2117766 34.5753425,78.5753425 Z",
    fill: "#2684FF"
  }))))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "integration-pagerduty",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3FB00D",
    d: "M30.5 32.4h-9.5c-1 0-1.9 0.8-1.9 1.9v13.4h11.4c1 0 1.9-0.8 1.9-1.9V34.2C32.4 33.2 31.5 32.4 30.5 32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3FB00D",
    d: "M47.9 34.2v11.5c0 1 0.8 1.9 1.9 1.9h9.5c1 0 1.9-0.8 1.9-1.9V32.4H49.7C48.7 32.4 47.9 33.2 47.9 34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3FB00D",
    d: "M40 0.1c-22 0-39.9 17.9-39.9 39.9 0 22 17.9 39.9 39.9 39.9 22 0 39.9-17.9 39.9-39.9C79.9 18 62 0.1 40 0.1zM37.8 46.3c0 3.8-3 6.8-6.8 6.8H18.9v9.5h-5.5V33.6c0-3.8 3-6.8 6.8-6.8h10.7c3.8 0 6.8 3 6.8 6.8V46.3zM66.6 46.3c0 3.8-3 6.8-6.8 6.8H49.2c-3.8 0-6.8-3-6.8-6.8V33.6c0-3.8 3-6.8 6.8-6.8h11.9v-9.4h5.5V46.3z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "integration-victorops",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0.1c-22 0-39.9 17.9-39.9 39.9 0 22 17.9 39.9 39.9 39.9 22 0 39.9-17.9 39.9-39.9C79.9 18 62 0.1 40 0.1zM59.7 40.7l-12.2 5.8 -0.2 1.9 9.3-2.8 -4.7 5.5 -0.4 1.8 -5.7 2.4 -0.6 1.7 2.5-1 -6.9 7.5 -0.2 6.2v5.7h-1.2v-5.5l-0.3-6.5 -6.9-7.5 2.5 1 -0.6-1.7 -5.7-2.4 -0.4-1.8 -4.7-5.5 9.3 2.8 -0.2-1.9 -12.2-5.8 2.7-4.4 -5.8-7.7 15.9 7.3 0.3-2.2 -4.7-7.2 0.7-1.2 -2.1-8.4 8.4 8.3 0.5-4.6 -2.5-6.9 3.3 1.1 2.9-8.4 2.9 8.4 3.3-1.1 -2.5 6.9 0.5 4.6 8.4-8.3 -2.1 8.4 0.7 1.2 -4.7 7.2 0.3 2.2 15.9-7.3 -5.8 7.7L59.7 40.7z",
    fill: "#FBB040"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "integration-webhook",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#434343"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9 37.6L46.4 37.6C47.4 35.6 49.5 34.3 51.8 34.3 55.2 34.3 58 37.1 58 40.7 58 44.2 55.2 47 51.8 47 49.3 47 47.2 45.6 46.2 43.4L29.9 43.4C28.7 47.8 24.8 51 20.2 51 14.5 51 10 46.3 10 40.5 10 34.7 14.5 30 20.2 30 24.8 30 28.7 33.2 29.9 37.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 46.4L41.1 46.4C43.3 50 47.2 52.3 51.8 52.3 58.7 52.3 64.3 46.8 64.3 39.9 64.3 32.9 58.7 27.4 51.8 27.4 47.6 27.4 44 29.3 41.7 32.4L35.5 32.4C38.4 26.3 44.6 22 51.9 22 61.9 22 70 30.1 70 40 70 49.9 61.9 58 51.9 58 44.2 58 37.6 53.2 35 46.4Z"
  }))))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "integration-slack",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0.1c-22 0-39.9 17.9-39.9 39.9 0 22 17.9 39.9 39.9 39.9 22 0 39.9-17.9 39.9-39.9C79.9 18 62 0.1 40 0.1z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1 61c-2 0-3.8-1.3-4.5-3.2L38.5 18.9c-0.8-2.5 0.5-5.2 3-6 2.5-0.8 5.2 0.5 6 3L60.6 54.8c0.8 2.5-0.5 5.2-3 6C57.1 60.9 56.6 61 56.1 61z",
    fill: "#E9A821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6 67.4c-2 0-3.8-1.3-4.5-3.2L19 25.2c-0.8-2.5 0.5-5.2 3-6 2.5-0.8 5.2 0.5 6 3l13.1 38.9c0.8 2.5-0.5 5.2-3 6C37.6 67.3 37.1 67.4 36.6 67.4z",
    fill: "#40BA91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5 43c0 2-1.3 3.8-3.2 4.5L25.4 60.6c-2.5 0.8-5.2-0.5-6-3 -0.8-2.5 0.5-5.2 3-6L61.2 38.5c2.5-0.8 5.2 0.5 6 3C67.4 42 67.5 42.5 67.5 43z",
    fill: "#E11664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9 23.7c0 2-1.3 3.8-3.2 4.5L18.8 41.3c-2.5 0.8-5.2-0.5-6-3 -0.8-2.5 0.5-5.2 3-6l38.9-13.1c2.5-0.8 5.2 0.5 6 3C60.8 22.7 60.9 23.2 60.9 23.7z",
    fill: "#6FCBDC"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "integration-msteams",
    viewBox: "0 0 80 80"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 80 0 80 80 0 80",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3 36.7L63.3 36.7 63.3 23.3C63.3 19.7 60.3 16.7 56.7 16.7L43.3 16.7 43.3 11.7C43.3 7.1 39.6 3.3 35 3.3 30.4 3.3 26.7 7.1 26.7 11.7L26.7 16.7 13.3 16.7C9.7 16.7 6.7 19.7 6.7 23.3L6.7 36 11.7 36C16.6 36 20.7 40 20.7 45 20.7 50 16.6 54 11.7 54L6.7 54 6.7 66.7C6.7 70.3 9.7 73.3 13.3 73.3L26 73.3 26 68.3C26 63.4 30 59.3 35 59.3 40 59.3 44 63.4 44 68.3L44 73.3 56.7 73.3C60.3 73.3 63.3 70.3 63.3 66.7L63.3 53.3 68.3 53.3C72.9 53.3 76.7 49.6 76.7 45 76.7 40.4 72.9 36.7 68.3 36.7Z",
    fill: "#6d7a7d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.10449e363aff3a107e7e6e40cfcee834.svg";
export { ForwardRef as ReactComponent };